import React from 'react';
import {AuthedLayout} from 'components/Layout';

const PreferencesLazy = React.lazy(() => import(/* webpackChunkName: "Preferences" */ './Preferences'));

export const Preferences = props => <AuthedLayout component={PreferencesLazy} {...props} />;
